'use client'

import { Navbar } from 'components/navbar'
import { Footer } from 'components/footer'
import { PostSubmissionSummary } from 'components/Projects/post-submission-summary'
import { SubmissionReceivedScreen } from 'components/Projects/submission-received-screen'
import { useParams } from 'react-router-dom'
import { ProjectBreadcrumbs } from 'components/Projects/project-breadcrumbs'
import { CarouselBanner } from 'components/carousel-banner'
import { useEffect, useState } from 'react'
import useListV2 from 'hooks/useListV2'
import { fetchDealById, updateDeal } from 'submission/lib/deal-api'

const upsertFirstUnlockTimeline = (timelines: any[], tgeDate: string) => {
  const filteredTimelines = timelines.filter(
    (entry: any) => entry?.type !== 'firstUnlock',
  )
  return [...filteredTimelines, { type: 'firstUnlock', datetime: tgeDate }]
}

export default function ProjectDetailPage() {
  const params = useParams()

  const projectId = params.projectId as string

  const { data: projects = [], mutate } = useListV2()
  const project = projects.find((p) => p.id.toString() === projectId.toString())

  const [showTgeDateModal, setShowTgeDateModal] = useState(false)
  const [isSavingTge, setIsSavingTge] = useState(false)
  const [tgeError, setTgeError] = useState<string | null>(null)
  const [dealPayload, setDealPayload] = useState<any>(null)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [projectId])

  const handleTgeDateUpdate = async (newTgeDate: string) => {
    if (!projectId) return
    try {
      setIsSavingTge(true)
      setTgeError(null)
      const payload = dealPayload || (await fetchDealById(projectId))
      setDealPayload(payload)

      const existingTimelines = Array.isArray(payload?.metadata?.timelines)
        ? payload.metadata.timelines
        : []
      const updatedTimelines = upsertFirstUnlockTimeline(
        existingTimelines,
        newTgeDate,
      )

      const updatedPayload = {
        ...payload,
        metadata: {
          ...payload.metadata,
          timelines: updatedTimelines,
        },
      }

      await updateDeal(projectId, updatedPayload)
      await mutate()
      setShowTgeDateModal(false)
    } catch (error) {
      console.error('Failed to update TGE date', error)
      setTgeError('Unable to save TGE date. Please try again.')
    } finally {
      setIsSavingTge(false)
    }
  }

  const isUnderReview = project?.status === 'Under Review'
  const shouldShowActionBanner =
    project?.status === 'Completed' && !project?.tgeDate

  return (
    <div className="flex flex-col min-h-screen bg-neutral-white font-sans text-slate-400">
      <Navbar />
      {project && (
        <>
          {shouldShowActionBanner && (
            <CarouselBanner
              type="Ending Soon"
              message={`Action required: TGE date is missing for ${project.projectName}. Please set the token generation event (TGE) date to continue.`}
              buttonText="Set TGE Date"
              buttonAction={() => setShowTgeDateModal(true)}
            />
          )}
          <ProjectBreadcrumbs projectTitle={project.projectName} />
          <main className="flex-1 flex flex-col bg-neutral-50">
            {isUnderReview ? (
              <SubmissionReceivedScreen dealId={project.id} />
            ) : (
              <PostSubmissionSummary
                project={project}
                showTgeDateModal={showTgeDateModal}
                setShowTgeDateModal={setShowTgeDateModal}
                onTgeDateUpdate={handleTgeDateUpdate}
                isSavingTge={isSavingTge}
                tgeError={tgeError}
              />
            )}
          </main>
        </>
      )}
      <Footer />
    </div>
  )
}
